var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMarkerGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00001 0.75C2.68286 0.75 7.62939e-06 3.33225 7.62939e-06 6.525C7.62939e-06 10.8562 6.00001 17.25 6.00001 17.25C6.00001 17.25 12 10.8562 12 6.525C12 3.33225 9.31715 0.75 6.00001 0.75ZM6.00001 8.5875C4.81715 8.5875 3.85715 7.6635 3.85715 6.525C3.85715 5.3865 4.81715 4.4625 6.00001 4.4625C7.18286 4.4625 8.14286 5.3865 8.14286 6.525C8.14286 7.6635 7.18286 8.5875 6.00001 8.5875Z",
    fill: "#4A5257"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerGrey);
export default __webpack_public_path__ + "static/media/map-marker-grey.3019e3cdca08d0fde09b9b6f6d609ad2.svg";
export { ForwardRef as ReactComponent };